import { createRootRoute, HeadContent, Outlet } from "@tanstack/react-router";
import { Suspense, lazy } from "react";

import { ToastProvider } from "@app/components/toast";

// Development only, the same way the design lab is: `import.meta.env.DEV` is
// replaced with `false` when Vite builds, so the conditional is a constant and
// the bundler drops the dynamic import with it. The devtools were mounted
// unconditionally and shipped — an "Open TanStack Router Devtools" button was
// sitting on every production page, the onboarding funnel included.
const Devtools = import.meta.env.DEV
  ? lazy(() =>
      import("@tanstack/router-devtools").then((m) => ({
        default: m.TanStackRouterDevtools,
      }))
    )
  : null;

export const Route = createRootRoute({
  component: () => (
    <ToastProvider>
      <HeadContent />
      <Outlet />
      {Devtools && (
        <Suspense fallback={null}>
          <Devtools />
        </Suspense>
      )}
    </ToastProvider>
  ),
});
